/**
 * Domain Adapter — Defence / Military (STANAG 4774)
 *
 * Phase-2 deliverable. Covers military installation assets using CityGML
 * Military ADE and NATO STANAG 4774/4778 classification markings.
 * Not-yet-implemented; returns an explicit typed error.
 */

import type { SceneItem } from "@/sdk-stub/gtwin-sdk/types";
import type { DomainAdapter, DomainAdapterContext, AdapterResult } from "../DomainAdapter";

export const MilitaryAdeAdapter: DomainAdapter = {
  domain: "defence",
  version: "1.0.0",
  standard: "STANAG-4774",

  /**
   * Detects military / defence assets.
   * Matches `layerKind === "stanag"` or explicit domain extension.
   */
  detect(item: SceneItem): boolean {
    type Extended = SceneItem & { extensions?: { geosoft?: { domain?: string } } };
    const ext = (item as Extended).extensions?.geosoft;
    if (ext?.domain === "defence") return true;
    return item.layerKind === "stanag";
  },

  async buildManifest(
    _item: SceneItem,
    _asset: { layerId: string; assetNodeId: string; gtwinId: string },
    _context: DomainAdapterContext,
  ): Promise<AdapterResult> {
    return {
      ok: false,
      error: {
        kind: "not-implemented",
        domain: "defence",
        message:
          "Phase 2 deliverable; fall back to synthetic Tier-1 view.",
      },
    };
  },
};
